import { CountryEnum } from 'api';
import React, { FunctionComponent } from 'react';
import Translate from 'ui/atoms/translate';
import makeForm from 'ui/forms';
import Grid, { Col } from 'ui/atoms/grid';
import { validateAlphanumericZIP } from 'ui/helper/validators';
import Header from 'ui/atoms/header';
import Section from 'ui/atoms/section';
import { BenefitingPersonEditType } from './hooks/use-edit-benefiting-person';
import useCountries from 'src/hooks/use-countries';

export interface BenefitingPersonDataFormProps {
  benefitingPerson: BenefitingPersonEditType;
  onChange: (values: BenefitingPersonEditType) => void;
}
export interface BenefitingPersonFormFields {
  forename: string;
  surname: string;
  street: string;
  zip: string;
  city: string;
  country: CountryEnum;
  birthDate: Date | null;
  birthPlace: string;
  id: string;
  usTax: boolean;
}

const BenefitingPersonForm = makeForm<BenefitingPersonFormFields>();

const BenefitingPersonDataForm: FunctionComponent<BenefitingPersonDataFormProps> = (props) => {
  const { benefitingPerson, onChange } = props;

  return (
    <BenefitingPersonForm initial={benefitingPerson} i18nKey="benefitingPersons" onChange={onChange}>
      <Section spacing="regular">
        <Header spacing="medium">
          <Translate name={'kycComplianceDetails.addManualReview.personalDataSubtitle'} />
        </Header>
        <BenefitingPersonForm.Group required={true} name="forename">
          <BenefitingPersonForm.Input autoFocus={true} value={benefitingPerson.forename} />
        </BenefitingPersonForm.Group>
        <BenefitingPersonForm.Group required={true} name="surname">
          <BenefitingPersonForm.Input />
        </BenefitingPersonForm.Group>
        <BenefitingPersonForm.Group name="birthDate" labelSpacing="tiny" labelSize="small" required={true}>
          <BenefitingPersonForm.DateInput max={new Date()} />
          {BenefitingPersonForm.Validators.Over18()}
        </BenefitingPersonForm.Group>
        <BenefitingPersonForm.Group name="birthPlace" required={true}>
          <BenefitingPersonForm.Input />
        </BenefitingPersonForm.Group>
      </Section>

      <Section spacing="small">
        <Header spacing="medium">
          <Translate name={'kycComplianceDetails.addManualReview.addressSubtitle'} />
        </Header>
        <BenefitingPersonForm.Group required={true} name="street">
          <BenefitingPersonForm.Input />
        </BenefitingPersonForm.Group>
        <Grid>
          <Col leftCol width={4}>
            <BenefitingPersonForm.Group required={true} name="zip">
              <BenefitingPersonForm.Input />
              <BenefitingPersonForm.Validation validate={validateAlphanumericZIP} />
            </BenefitingPersonForm.Group>
          </Col>
          <Col rightCol width={8}>
            <BenefitingPersonForm.Group required={true} name="city">
              <BenefitingPersonForm.Input />
            </BenefitingPersonForm.Group>
          </Col>
        </Grid>
        <BenefitingPersonForm.Group required={true} name="country">
          <BenefitingPersonForm.Select
            options={useCountries()}
            value={benefitingPerson.country}
          ></BenefitingPersonForm.Select>
        </BenefitingPersonForm.Group>
      </Section>

      <Section spacing="regular">
        <BenefitingPersonForm.Group name="usTax" required={true}>
          <BenefitingPersonForm.Checkbox disabled>
            <Translate name="kycComplianceDetails.addManualReview.usTaxCheckbox" />
          </BenefitingPersonForm.Checkbox>
        </BenefitingPersonForm.Group>
      </Section>

      <Section spacing="regular">
        <BenefitingPersonForm.GenericErrorMessages />
      </Section>
    </BenefitingPersonForm>
  );
};

export default BenefitingPersonDataForm;
